import CheckIcon from '@mui/icons-material/Check';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import ClearIcon from '@mui/icons-material/Clear';
import ElectricBoltIcon from '@mui/icons-material/ElectricBolt';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import FilterNoneIcon from '@mui/icons-material/FilterNone';
import InfoOutlinedIcon from '@mui/icons-material/Info';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import {
  Alert,
  Box,
  Button,
  Card,
  Container,
  Divider,
  Grid,
  Link,
  Paper,
  Stack,
  Typography,
} from '@mui/material';
import Rating from '@mui/material/Rating';
import React, { useEffect, useRef, useState } from 'react';

import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';

const bestform2290software = () => {
  const containerRef = useRef(null);

  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [removelistener, setRemovelistener] = useState(true);
  const [tempReturn, setTempReturn] = useState(false);
  // Define an array of imported images
  const images = [
    '/assets/images/2290-steps-img.webp',
    '/assets/images/easy-steps-img.webp',
    '/assets/images/941-steps-img.webp',
    // Add more image URLs as needed
  ];
  const Ref = React.useRef<HTMLDivElement>(null);

  // Handle scrolling to change images
  const handleScroll = (event: any) => {
    const delta = event.deltaY;
    if (delta > 0) {
      // Scroll down, show the next imag
      if (currentImageIndex < 2) {
        setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
        setRemovelistener(false);
      } else {
        setRemovelistener(true);
      }
    } else if (delta < 0) {
      // Scroll up, show the previous image
      if (currentImageIndex > 0) {
        setCurrentImageIndex((prevIndex) =>
          prevIndex === 0 ? images.length - 1 : prevIndex - 1
        );
        setRemovelistener(false);
      } else {
        setRemovelistener(true);
      }
    } else {
      setRemovelistener(false);
    }
  };
  function useHorizontalScroll() {
    useEffect(() => {
      const el = Ref.current;
      setTempReturn(tempReturn);
      if (el) {
        const onWheel = (e: any) => {
          if (e.deltaY === 0) return;
          e.preventDefault();
          el.scrollTo({
            behavior: 'smooth',
            top: 0,
            left: 0,
          });
        };

        el.addEventListener('wheel', onWheel);
        if (removelistener === false) {
          el.addEventListener('wheel', onWheel);
        } else if (removelistener === true) {
          el.removeEventListener('wheel', onWheel);
        } else {
          el.addEventListener('wheel', onWheel);
        }
        return () => {
          el.removeEventListener('wheel', onWheel);
        };
      }
      return () => setTempReturn(false);
    }, [removelistener]);
    return Ref;
  }

  const scrollRef = useHorizontalScroll();

  return (
    <AppLayout
      // LayoutWrapperContents={layoutWrapperContents}
      meta={
        <Meta
          title="Best Form 2290 E-File Software (2026)"
          description="Compare the best Form 2290 e-file software for 2026. Explore features, pricing, and benefits to choose the right IRS-authorized HVUT filing solution."
          keywords=""
          canonical="comparison/best-form-2290-software/"

          // jsonLdPricing="89.99"
          // jsonLdAggregateRatingValue="4.99"
          // jsonLdAggregateRatingCount="3021"
        />
      }
    >
      <Box
        sx={{
          mt: 0,
          pt: 8,
          pb: 8,
          position: 'relative',
          background: `
  linear-gradient(
    180deg,
    #e9eeff 0%,
    #edfaf1 50%,
    #ffffff 100%
  )
`,
          overflow: 'hidden',
        }}
        component="section"
      >
        <Container maxWidth="lg">
          <Box
            sx={{
              textAlign: 'center',
            }}
          >
            <Typography
              variant="h1"
              sx={{
                fontSize: {
                  xs: 24,
                  sm: 30,
                  md: 38,
                  lg: 48,
                  xl: 56,
                },
                fontWeight: 700,
                color: '#1a1a1a',
                mb: 3,
                lineHeight: 1.2,
              }}
            >
              Best IRS Form 2290 E-File Software for Truckers & Fleet Owners{' '}
              <br />
            </Typography>

            <Typography
              variant="body1"
              sx={{
                fontSize: {
                  xs: 16,
                  sm: 18,
                  md: 20,
                },
                fontWeight: 400,
                mb: 4,
                color: '#5b6472',
                lineHeight: 1.7,
                maxWidth: 950,
                mx: 'auto',
              }}
            >
              Choosing the right Form 2290 e-file software can depend on your
              fleet size, filing volume, budget, and support needs. Compare
              leading Form 2290 e-file providers by pricing, features, ease of
              filing, VIN corrections, support and more to find the right fit
              for your business.
            </Typography>

            <Stack
              alignItems="center"
              sx={{
                width: '100%',
                mt: 3,
              }}
            >
              <Button
                variant="contained"
                className="btn-primary"
                sx={{
                  backgroundColor: '#1e2f8f',
                  color: '#ffffff',
                  fontWeight: 700,
                  fontSize: 16,
                  px: 4,
                  py: 1.5,
                  borderRadius: 2,
                  textTransform: 'none',
                  boxShadow: 'none',
                  transition: 'all 0.3s ease',
                  '&:hover, &:focus, &:active': {
                    backgroundColor: '#16247a',
                    transform: 'scale(1.05)',
                  },
                }}
                href="#compareoption"
              >
                Compare Your Options
              </Button>

              {/* <Typography
                variant="body2"
                sx={{
                  mt: 2,
                  fontSize: 14,
                  color: '#9aa1ab',
                  fontWeight: 500,
                }}
              >
                No credit card required. Pay only when you file.
              </Typography> */}
            </Stack>
            {/* 
            <Typography
              sx={{
                mt: 0.5,
                fontSize: 11.5,
                color: '#98a2b3',
                textAlign: 'center',
              }}
            >
              Based on customer reviews
            </Typography> */}
          </Box>
        </Container>
      </Box>
      <Grid
        container
        sx={{
          backgroundColor: '#ffffff',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
          flexDirection: 'column',
        }}
        spacing={2}
        m={0}
        component="section"
        aria-labelledby="compare-taxzerone"
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            sx={{ mt: { xs: 2, sm: 6, md: 6 } }}
            className="MuiGrid-root-width"
          >
            <Grid size={12} textAlign="center">
              <Typography
                variant="h2"
                sx={{
                  fontSize: {
                    xs: 24,
                    sm: 28,
                    md: 34,
                    lg: 42,
                    xl: 48,
                  },
                  fontWeight: 600,
                  mb: 1,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                Compare TaxZerone{' '}
                <span
                  style={{
                    fontWeight: 500,
                    fontSize: 'clamp(18px, 3vw, 38px)',
                  }}
                >
                  vs
                </span>{' '}
                Alternatives
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: {
                    xs: 16,
                    sm: 18,
                    md: 18,
                    lg: 20,
                    xl: 22,
                  },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 2,
                  textAlign: 'center',
                }}
              >
                Explore how TaxZerone and other popular Form 2290 e-file
                providers compare <br />
                across pricing, filing features and ease of use.
              </Typography>
            </Grid>
          </Grid>
        </Container>

        <Container
          maxWidth="xl"
          sx={{ mb: 5 }}
          ref={scrollRef}
          className="image-gallery"
          onWheel={handleScroll}
        >
          <Box sx={{ px: { xs: 2, md: 3 } }}>
            <Box
              ref={containerRef}
              sx={{
                overflow: 'hidden',
                py: 2,
              }}
            >
              <Stack
                direction={{ xs: 'column', md: 'row' }}
                spacing={2}
                sx={{
                  alignItems: 'stretch',
                  justifyContent: 'center',
                  p: 2,
                  maxWidth: '1200px',
                  mx: 'auto',
                }}
              >
                {/* Card 1 */}
                <Box
                  sx={{
                    flex: { xs: '1 1 100%', md: '1 1 0' },
                    width: '100%',
                    display: 'flex',
                  }}
                >
                  <Card
                    sx={{
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      borderRadius: '20px',
                      overflow: 'hidden',
                      background: '#ffffff',
                      position: 'relative',
                      border: '1px solid #EDEDED',
                      transition: 'all 0.3s ease',
                      cursor: 'pointer',
                      boxShadow: '0 4px 16px rgba(0, 0, 0, 0.05)',
                      '&:hover': {
                        boxShadow: '0 10px 24px rgba(0, 0, 0, 0.1)',
                      },
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        pt: 4,
                        pb: 2,
                        px: 2,
                        height: 140,
                      }}
                    >
                      <Box
                        component="img"
                        src="/assets/images/taxzerone-vs2290-expresstrucktax.png"
                        alt="taxzerone vs2290 expresstrucktax"
                        sx={{
                          maxWidth: '100%',
                          maxHeight: '100%',
                          objectFit: 'contain',
                        }}
                      />
                    </Box>

                    <Box
                      sx={{
                        p: 3,
                        display: 'flex',
                        flexDirection: 'column',
                        flexGrow: 1,
                        justifyContent: 'space-between',
                      }}
                    >
                      <Box>
                        <Typography
                          component="h3"
                          sx={{
                            fontSize: 18,
                            fontWeight: 700,
                            color: '#111827',
                            mb: 1.5,
                          }}
                        >
                          TaxZerone vs. ExpressTruckTax
                        </Typography>

                        <Typography
                          sx={{
                            fontSize: 13.5,
                            lineHeight: 1.6,
                            color: '#6B7280',
                            mb: 3,
                          }}
                        >
                          Tired of upsells and add-on fees? See why fleets are
                          switching to TaxZerone for transparent pricing, a
                          faster filing process...
                        </Typography>
                      </Box>

                      <Button
                        variant="contained"
                        href="/comparison/taxzerone-vs-expresstrucktax"
                        fullWidth
                        sx={{
                          backgroundColor: '#333333',
                          color: '#ffffff',
                          fontWeight: 700,
                          fontSize: 14,
                          py: 1.2,
                          borderRadius: 6,
                          textTransform: 'none',
                          boxShadow: 'none',
                          '&:hover': {
                            backgroundColor: '#000000',
                          },
                        }}
                      >
                        Compare
                      </Button>
                    </Box>
                  </Card>
                </Box>

                {/* Card 2 */}
                <Box
                  sx={{
                    flex: { xs: '1 1 100%', md: '1 1 0' },
                    width: '100%',
                    display: 'flex',
                  }}
                >
                  <Card
                    sx={{
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      borderRadius: '20px',
                      overflow: 'hidden',
                      background: '#ffffff',
                      position: 'relative',
                      border: '1px solid #EDEDED',
                      transition: 'all 0.3s ease',
                      cursor: 'pointer',
                      boxShadow: '0 4px 16px rgba(0, 0, 0, 0.05)',
                      '&:hover': {
                        boxShadow: '0 10px 24px rgba(0, 0, 0, 0.1)',
                      },
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        pt: 4,
                        pb: 2,
                        px: 2,
                        height: 140,
                      }}
                    >
                      <Box
                        component="img"
                        src="/assets/images/taxzerone-vs2290-eform2290.png"
                        alt="taxzerone vs2290 eform2290"
                        sx={{
                          maxWidth: '100%',
                          maxHeight: '100%',
                          objectFit: 'contain',
                        }}
                      />
                    </Box>

                    <Box
                      sx={{
                        p: 3,
                        display: 'flex',
                        flexDirection: 'column',
                        flexGrow: 1,
                        justifyContent: 'space-between',
                      }}
                    >
                      <Box>
                        <Typography
                          component="h3"
                          sx={{
                            fontSize: 18,
                            fontWeight: 700,
                            color: '#111827',
                            mb: 1.5,
                          }}
                        >
                          TaxZerone vs. eForm2290
                        </Typography>

                        {/* <Typography
                          sx={{
                            fontSize: 14,
                            fontWeight: 600,
                            color: '#111827',
                            mb: 0.5,
                          }}
                        >
                          Choosing the right tax e-file provider matters.
                        </Typography> */}

                        <Typography
                          sx={{
                            fontSize: 13.5,
                            lineHeight: 1.6,
                            color: '#6B7280',
                            mb: 3,
                          }}
                        >
                          Choosing the right HVUT e-file provider matters.
                          Compare both platforms and see how TaxZerone
                          simplifies filing with affordable pricing...
                        </Typography>
                      </Box>

                      <Button
                        variant="contained"
                        href="/comparison/taxzerone-vs-eform2290"
                        fullWidth
                        sx={{
                          backgroundColor: '#333333',
                          color: '#ffffff',
                          fontWeight: 700,
                          fontSize: 14,
                          py: 1.2,
                          borderRadius: 6,
                          textTransform: 'none',
                          boxShadow: 'none',
                          '&:hover': {
                            backgroundColor: '#000000',
                          },
                        }}
                      >
                        Compare
                      </Button>
                    </Box>
                  </Card>
                </Box>

                {/* Card 3 */}
                <Box
                  sx={{
                    flex: { xs: '1 1 100%', md: '1 1 0' },
                    width: '100%',
                    display: 'flex',
                  }}
                >
                  <Card
                    sx={{
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      borderRadius: '20px',
                      overflow: 'hidden',
                      background: '#ffffff',
                      position: 'relative',
                      border: '1px solid #EDEDED',
                      transition: 'all 0.3s ease',
                      cursor: 'pointer',
                      boxShadow: '0 4px 16px rgba(0, 0, 0, 0.05)',
                      '&:hover': {
                        boxShadow: '0 10px 24px rgba(0, 0, 0, 0.1)',
                      },
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        pt: 4,
                        pb: 2,
                        px: 2,
                        height: 140,
                      }}
                    >
                      <Box
                        component="img"
                        src="/assets/images/taxzerone-vs2290-simpletrucktax.png"
                        alt="taxzerone vs2290 simpletrucktax"
                        sx={{
                          maxWidth: '100%',
                          maxHeight: '100%',
                          objectFit: 'contain',
                        }}
                      />
                    </Box>

                    <Box
                      sx={{
                        p: 3,
                        display: 'flex',
                        flexDirection: 'column',
                        flexGrow: 1,
                        justifyContent: 'space-between',
                      }}
                    >
                      <Box>
                        <Typography
                          component="h3"
                          sx={{
                            fontSize: 18,
                            fontWeight: 700,
                            color: '#111827',
                            mb: 1.5,
                          }}
                        >
                          TaxZerone vs. SimpleTruckTax
                        </Typography>

                        {/* <Typography
                          sx={{
                            fontSize: 14,
                            fontWeight: 600,
                            color: '#111827',
                            mb: 0.5,
                          }}
                        >
                          Looking for a simpler e-filing experience?
                        </Typography> */}

                        <Typography
                          sx={{
                            fontSize: 13.5,
                            lineHeight: 1.6,
                            color: '#6B7280',
                            mb: 3,
                          }}
                        >
                          Looking for a simpler e-filing experience? Compare
                          pricing, features, and filing solutions to see why
                          businesses choose TaxZerone...
                        </Typography>
                      </Box>

                      <Button
                        variant="contained"
                        href="/comparison/taxzerone-vs-simpletrucktax"
                        fullWidth
                        sx={{
                          backgroundColor: '#333333',
                          color: '#ffffff',
                          fontWeight: 700,
                          fontSize: 14,
                          py: 1.2,
                          borderRadius: 6,
                          textTransform: 'none',
                          boxShadow: 'none',
                          '&:hover': {
                            backgroundColor: '#000000',
                          },
                        }}
                      >
                        Compare
                      </Button>
                    </Box>
                  </Card>
                </Box>
                {/* Card 3 */}
                <Box
                  sx={{
                    flex: { xs: '1 1 100%', md: '1 1 0' },
                    width: '100%',
                    display: 'flex',
                  }}
                >
                  <Card
                    sx={{
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      borderRadius: '20px',
                      overflow: 'hidden',
                      background: '#ffffff',
                      position: 'relative',
                      border: '1px solid #EDEDED',
                      transition: 'all 0.3s ease',
                      cursor: 'pointer',
                      boxShadow: '0 4px 16px rgba(0, 0, 0, 0.05)',
                      '&:hover': {
                        boxShadow: '0 10px 24px rgba(0, 0, 0, 0.1)',
                      },
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        pt: 4,
                        pb: 2,
                        px: 2,
                        height: 140,
                      }}
                    >
                      <Box
                        component="img"
                        src="/assets/images/taxzerone-vs2290-ez2290.png"
                        alt="taxzerone vs2290 ez2290"
                        sx={{
                          maxWidth: '100%',
                          maxHeight: '100%',
                          objectFit: 'contain',
                        }}
                      />
                    </Box>

                    <Box
                      sx={{
                        p: 3,
                        display: 'flex',
                        flexDirection: 'column',
                        flexGrow: 1,
                        justifyContent: 'space-between',
                      }}
                    >
                      <Box>
                        <Typography
                          sx={{
                            fontSize: 18,
                            fontWeight: 700,
                            color: '#111827',
                            mb: 1.5,
                          }}
                        >
                          TaxZerone vs. EZ2290
                        </Typography>

                        {/* <Typography
                          sx={{
                            fontSize: 14,
                            fontWeight: 600,
                            color: '#111827',
                            mb: 0.5,
                          }}
                        >
                          Looking for a simpler e-filing experience?
                        </Typography> */}

                        <Typography
                          sx={{
                            fontSize: 13.5,
                            lineHeight: 1.6,
                            color: '#6B7280',
                            mb: 3,
                          }}
                        >
                          See how the two platforms compare in terms of pricing,
                          VIN correction support, and how fast you get your
                          stamped Schedule 1...
                        </Typography>
                      </Box>

                      <Button
                        variant="contained"
                        href="/comparison/taxzerone-vs-ez2290"
                        fullWidth
                        sx={{
                          backgroundColor: '#333333',
                          color: '#ffffff',
                          fontWeight: 700,
                          fontSize: 14,
                          py: 1.2,
                          borderRadius: 6,
                          textTransform: 'none',
                          boxShadow: 'none',
                          '&:hover': {
                            backgroundColor: '#000000',
                          },
                        }}
                      >
                        Compare
                      </Button>
                    </Box>
                  </Card>
                </Box>
              </Stack>
            </Box>
          </Box>
        </Container>
      </Grid>
      <Box
        sx={{
          backgroundColor: '#eef9fa',
          my: { xs: 0, md: 8 },
          py: { xs: 4, md: 6 },
        }}
        component="section"
        aria-labelledby="business-compare-form2290"
      >
        <Container
          maxWidth="lg"
          sx={{ px: { xs: 2, md: 4 }, py: { xs: 4, md: 6 } }}
        >
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            alignItems="center"
            justifyContent="space-between"
            spacing={4}
            sx={{ my: { xs: 0, md: -23 } }}
          >
            {/* LEFT: TEXT */}
            <Box
              sx={{
                flex: 1,
                maxWidth: { md: 560 },
              }}
            >
              <Typography
                variant="h2"
                sx={{
                  fontWeight: 600,

                  fontSize: {
                    xs: 24,
                    sm: 28,
                    md: 34,
                    lg: 42,
                    xl: 48,
                  },
                  lineHeight: 1.3,
                  mb: 2,
                }}
              >
                Why Businesses Compare Form 2290 E-File Software?
              </Typography>

              <Typography
                sx={{
                  // lineHeight: 1.8,
                  color: '#4B5563',
                  fontSize: 15.5,
                  mb: 1,
                }}
              >
                Businesses compare Form 2290 e-file software to find a solution
                that best fits their{' '}
                <strong style={{ fontWeight: 600 }}>
                  filing volume, fleet size, and support needs
                </strong>
                . Key factors include:
              </Typography>
              <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                <li>
                  <strong style={{ fontWeight: 600 }}>
                    {' '}
                    Pricing That Scales:
                  </strong>{' '}
                  Competitive rates for individual returns, multiple vehicles,
                  and high-volume fleets.
                </li>
                <li>
                  <strong style={{ fontWeight: 600 }}>
                    {' '}
                    Easy Corrections:
                  </strong>{' '}
                  Simple amendments and VIN correction options when changes are
                  needed.
                </li>
                <li>
                  <strong style={{ fontWeight: 600 }}>Quick Schedule 1</strong>{' '}
                  Fast delivery of the IRS-stamped Schedule 1 after acceptance.
                </li>
                <li>
                  <strong style={{ fontWeight: 600 }}>
                    {' '}
                    Bilingual Assistance:
                  </strong>{' '}
                  Dedicated
                  <strong style={{ fontWeight: 600 }}>
                    {' '}
                    English and Spanish support{' '}
                  </strong>
                  when you need filing help.
                </li>
                <li>
                  <strong style={{ fontWeight: 600 }}>
                    {' '}
                    Flexible Fleet Filing:
                  </strong>{' '}
                  Options designed for single trucks, multiple vehicles, and
                  larger fleets.
                </li>
              </Box>
            </Box>

            {/* RIGHT: IMAGE WITH FLOATING LABELS */}
            <Box
              sx={{
                position: 'relative',
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                maxWidth: { xs: 280, sm: 340, md: 380 },
                mx: 'auto',
                my: { xs: 0, md: 4 },

                px: { xs: 2, sm: 0 },
              }}
            >
              <Box
                component="img"
                src="/assets/images/why-compare-form-941-e-file-software-img.webp"
                alt="TaxZerone mascot in a suit holding a briefcase"
                sx={{
                  width: '100%',
                  height: 'auto',
                  display: 'block',
                  position: 'relative',
                  zIndex: 1,
                }}
              />

              {/* 1. Transparent Pricing */}
              <Box
                sx={{
                  position: 'absolute',
                  top: { xs: '7%', sm: '10%', md: '18%' },
                  left: { xs: '-5%', sm: '-12%', md: '-15%' },
                  bgcolor: '#FBE4E0',
                  color: '#0F172A',
                  fontSize: { xs: 10, sm: 12, md: 14 },
                  fontWeight: 600,
                  px: { xs: 1.5, sm: 2, md: 2.5 },
                  py: { xs: 0.8, sm: 1.2, md: 1.5 },
                  borderRadius: 2,
                  boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                  zIndex: 2,
                  textAlign: 'center',
                  whiteSpace: 'nowrap',
                  opacity: 0.85,
                }}
              >
                Pricing That Scales
              </Box>

              {/* 2. Instant Email Notifications */}
              <Box
                sx={{
                  position: 'absolute',
                  top: { xs: '38%', sm: '40%', md: '42%' },
                  right: { xs: '-8%', sm: '-20%', md: '-25%' },
                  bgcolor: '#F7D9CE',
                  color: '#0F172A',
                  fontSize: { xs: 10, sm: 12, md: 14 },
                  fontWeight: 600,
                  px: { xs: 1.5, sm: 2, md: 2.5 },
                  py: { xs: 0.8, sm: 1.2, md: 1.5 },
                  borderRadius: 2,
                  textAlign: 'center',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                  zIndex: 2,
                  whiteSpace: 'nowrap',
                  opacity: 0.85,
                }}
              >
                Easy Corrections
              </Box>

              <Box
                sx={{
                  position: 'absolute',
                  top: { xs: '18%', sm: '20%', md: '22%' },
                  right: { xs: '-22%', sm: '-24%', md: '-34%' },
                  bgcolor: '#cff7ce',
                  color: '#0F172A',
                  fontSize: { xs: 10, sm: 12, md: 14 },
                  fontWeight: 600,
                  px: { xs: 1.5, sm: 2, md: 2.5 },
                  py: { xs: 0.8, sm: 1.2, md: 1.5 },
                  borderRadius: 2,
                  textAlign: 'center',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                  zIndex: 2,
                  whiteSpace: 'nowrap',
                  opacity: 0.85,
                }}
              >
                Flexible Fleet Filing
              </Box>

              {/* 3. Online Filing in Minutes */}
              <Box
                sx={{
                  position: 'absolute',
                  top: { xs: '58%', sm: '54%', md: '50%' },
                  left: { xs: '-6%', sm: '-8%', md: '-4%' },
                  bgcolor: '#E3DEF7',
                  color: '#0F172A',
                  fontSize: { xs: 10, sm: 12, md: 14 },
                  fontWeight: 600,
                  px: { xs: 1.5, sm: 2, md: 2.5 },
                  py: { xs: 0.8, sm: 1.2, md: 1.5 },
                  borderRadius: 2,
                  textAlign: 'center',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                  zIndex: 2,
                  whiteSpace: 'nowrap',
                  opacity: 0.85,
                }}
              >
                Quick Schedule 1
              </Box>

              {/* 4. Simplify Client Approvals */}
              <Box
                sx={{
                  position: 'absolute',
                  bottom: { xs: '5%', sm: '10%', md: '12%' },
                  left: { xs: '0%', sm: '5%', md: '8%' }, // Changed left to right offset on mobile for balanced visual alignment
                  bgcolor: '#F6D9E8',
                  color: '#0F172A',
                  fontSize: { xs: 10, sm: 12, md: 14 },
                  fontWeight: 600,
                  px: { xs: 1.5, sm: 2, md: 2.5 },
                  py: { xs: 0.8, sm: 1.2, md: 1.5 },
                  borderRadius: 2,
                  textAlign: 'center',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                  zIndex: 2,
                  whiteSpace: 'nowrap',
                  opacity: 0.85,
                }}
              >
                {' '}
                Dedicated English and Spanish support
              </Box>
            </Box>
          </Stack>
        </Container>
      </Box>
      <Grid
        container
        sx={{
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
          flexDirection: 'column',
        }}
        spacing={2}
        m={0}
        component="section"
        aria-labelledby="how-to-choose-right"
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            sx={{ mt: { xs: 2, sm: 6, md: 6 } }}
            className="MuiGrid-root-width"
          >
            <Grid size={12} textAlign="center">
              <Typography
                variant="h2"
                sx={{
                  fontSize: {
                    xs: 24,
                    sm: 28,
                    md: 34,
                    lg: 42,
                    xl: 48,
                  },
                  fontWeight: 600,
                  mb: 1,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                How to Choose the Right Platform
              </Typography>
            </Grid>
          </Grid>
        </Container>

        <Container
          maxWidth="lg"
          sx={{ mb: 5 }}
          ref={scrollRef}
          className="image-gallery"
          onWheel={handleScroll}
        >
          <Box sx={{ py: { xs: 2, md: 2 } }}>
            <Grid
              container
              spacing={2}
              justifyContent="center"
              alignItems="stretch"
              sx={{ p: 0 }}
            >
              <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Box
                  sx={{
                    height: '100%',
                    textAlign: { xs: 'center', md: 'left' },
                    maxWidth: { xs: '100%', md: 340 },
                    mx: { xs: 'auto', md: 0 },
                  }}
                >
                  <Box
                    sx={{
                      width: 64,
                      height: 64,
                      borderRadius: 3,
                      background: '#f8e7fb',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      mb: 3,
                      mx: { xs: 'auto', md: 0 },
                    }}
                  >
                    <ElectricBoltIcon
                      sx={{
                        color: '#c55ad9',
                        fontSize: 30,
                      }}
                    />
                  </Box>

                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 700,
                      mb: 1.5,
                    }}
                  >
                    Fast Schedule 1 Delivery
                  </Typography>

                  <Typography
                    sx={{
                      color: '#4b5563',
                      lineHeight: 1.8,
                    }}
                  >
                    Choose an IRS authorized e-file provider that delivers your
                    stamped schedule 1 in minutes after IRS acceptance.
                  </Typography>
                </Box>
              </Grid>

              <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Box
                  sx={{
                    height: '100%',
                    textAlign: { xs: 'center', md: 'left' },
                    maxWidth: { xs: '100%', md: 340 },
                    mx: { xs: 'auto', md: 0 },
                  }}
                >
                  <Box
                    sx={{
                      width: 64,
                      height: 64,
                      borderRadius: 3,
                      background: '#dff8e8',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      mb: 3,
                      mx: { xs: 'auto', md: 0 },
                    }}
                  >
                    <UploadFileIcon
                      sx={{
                        color: '#2e7d32',
                        fontSize: 30,
                      }}
                    />
                  </Box>

                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 700,
                      mb: 1.5,
                    }}
                  >
                    Easy-to-Use Filing Process
                  </Typography>

                  <Typography
                    sx={{
                      color: '#4b5563',
                      lineHeight: 1.8,
                    }}
                  >
                    A clean, guided workflow makes filing simple, especially for
                    first-time filers, reducing confusion and saving time.
                  </Typography>
                </Box>
              </Grid>

              <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Box
                  sx={{
                    height: '100%',
                    textAlign: { xs: 'center', md: 'left' },
                    maxWidth: { xs: '100%', md: 340 },
                    mx: { xs: 'auto', md: 0 },
                  }}
                >
                  <Box
                    sx={{
                      width: 64,
                      height: 64,
                      borderRadius: 3,
                      background: '#fff5df',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      mb: 3,
                      mx: { xs: 'auto', md: 0 },
                    }}
                  >
                    <FilterNoneIcon
                      sx={{
                        color: '#d38c30',
                        fontSize: 30,
                      }}
                    />
                  </Box>

                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 700,
                      mb: 1.5,
                    }}
                  >
                    Bulk Filing Support
                  </Typography>

                  <Typography
                    sx={{
                      color: '#4b5563',
                      lineHeight: 1.8,
                    }}
                  >
                    If you manage multiple vehicles, look for software that
                    supports bulk upload filing to streamline the process.
                  </Typography>
                </Box>
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Box
                  sx={{
                    height: '100%',
                    textAlign: { xs: 'center', md: 'left' },
                    maxWidth: { xs: '100%', md: 340 },
                    mx: { xs: 'auto', md: 0 },
                    mt: 4,
                  }}
                >
                  <Box
                    sx={{
                      width: 64,
                      height: 64,
                      borderRadius: 3,
                      background: '#dfe8ff',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      mb: 3,
                      mx: { xs: 'auto', md: 0 },
                    }}
                  >
                    <FactCheckIcon
                      sx={{
                        color: '#3056d3',
                        fontSize: 30,
                      }}
                    />
                  </Box>

                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 700,
                      mb: 1.5,
                    }}
                  >
                    Built-In Error Validation
                  </Typography>

                  <Typography
                    sx={{
                      color: '#4b5563',
                      lineHeight: 1.8,
                    }}
                  >
                    Automatic checks for missing or incorrect information help
                    prevent IRS rejections and reduce the need for
                    resubmissions.
                  </Typography>
                </Box>
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Box
                  sx={{
                    height: '100%',
                    textAlign: { xs: 'center', md: 'left' },
                    maxWidth: { xs: '100%', md: 340 },
                    mx: { xs: 'auto', md: 0 },
                    mt: 4,
                  }}
                >
                  <Box
                    sx={{
                      width: 64,
                      height: 64,
                      borderRadius: 3,
                      background: '#dff9ff',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      mb: 3,
                      mx: { xs: 'auto', md: 0 },
                    }}
                  >
                    <SupportAgentIcon
                      sx={{
                        color: '#309dd3',
                        fontSize: 30,
                      }}
                    />
                  </Box>

                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 700,
                      mb: 1.5,
                    }}
                  >
                    Support & Easy Corrections
                  </Typography>

                  <Typography
                    sx={{
                      color: '#4b5563',
                      lineHeight: 1.8,
                    }}
                  >
                    Choose a provider that offers responsive bilingual customer
                    support, Free VIN corrections, and easy amendments.
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        component="section"
        aria-labelledby="top-form2290-software"
      >
        <Container maxWidth="lg" sx={{ mb: 5, mt: 5 }}>
          <Box
            sx={{ py: 4, px: { xs: 2, md: 4 }, maxWidth: '1100px', mx: 'auto' }}
          >
            {/* HEADING */}
            <Typography
              variant="h2"
              id="compareoption"
              sx={{
                fontSize: {
                  xs: 24,
                  sm: 28,
                  md: 34,
                  lg: 42,
                  xl: 48,
                },
                fontWeight: 600,
                textAlign: 'center',
                mb: 3,
              }}
            >
              Top Form 2290 Software (2026)
            </Typography>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexWrap: 'wrap',
                mb: 5,
              }}
            >
              <Typography
                component="a"
                href="#taxzerone"
                sx={{
                  px: 2,
                  fontSize: '16px',
                  fontWeight: 500,
                  cursor: 'pointer',
                  textDecoration: 'none',
                  color: '#1e40af',
                  '&:hover': { textDecoration: 'underline' },
                }}
              >
                TaxZerone
              </Typography>

              <Divider
                orientation="vertical"
                flexItem
                sx={{ height: '20px' }}
              />
              <Typography
                component="a"
                href="#expresstrucktax"
                sx={{
                  px: 2,
                  fontSize: '16px',
                  fontWeight: 500,
                  cursor: 'pointer',
                  textDecoration: 'none',
                  color: '#1e40af',
                  '&:hover': { textDecoration: 'underline' },
                }}
              >
                ExpressTruckTax
              </Typography>

              <Divider
                orientation="vertical"
                flexItem
                sx={{ height: '20px' }}
              />
              <Typography
                component="a"
                href="#eform2290"
                sx={{
                  px: 2,
                  fontSize: '16px',
                  fontWeight: 500,
                  cursor: 'pointer',
                  textDecoration: 'none',
                  color: '#1e40af',
                  '&:hover': { textDecoration: 'underline' },
                }}
              >
                eform2290
              </Typography>
              <Divider
                orientation="vertical"
                flexItem
                sx={{ height: '20px' }}
              />
              <Typography
                component="a"
                href="#simpletruck"
                sx={{
                  px: 2,
                  fontSize: '16px',
                  fontWeight: 500,
                  cursor: 'pointer',
                  textDecoration: 'none',
                  color: '#1e40af',
                  '&:hover': { textDecoration: 'underline' },
                }}
              >
                SimpleTruckTax
              </Typography>
              <Divider
                orientation="vertical"
                flexItem
                sx={{ height: '20px' }}
              />
              <Typography
                component="a"
                href="#ez2290"
                sx={{
                  px: 2,
                  fontSize: '16px',
                  fontWeight: 500,
                  cursor: 'pointer',
                  textDecoration: 'none',
                  color: '#1e40af',
                  '&:hover': { textDecoration: 'underline' },
                }}
              >
                EZ2290
              </Typography>
            </Box>
            <Stack spacing={4}>
              <Box
                sx={{
                  backgroundColor: '#ffffff',
                  borderRadius: '16px',
                  border: '1px solid #E2E8F0',
                  overflow: 'hidden',
                  boxShadow: '0 4px 20px rgba(0,0,0,0.03)',
                }}
              >
                {/* Header Bar */}
                <Box
                  sx={{
                    backgroundColor: '#213e99',
                    color: '#ffffff',
                    px: { xs: 3.5, md: 4 },
                    py: { xs: 2.5, md: 3 },
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    flexWrap: 'wrap',
                    gap: 2,
                  }}
                >
                  <Box>
                    <Typography
                      variant="h5"
                      id="taxzerone"
                      sx={{
                        fontWeight: 600,
                        fontSize: { xs: '20px', md: '24px' },
                        scrollMarginTop: 83,
                      }}
                    >
                      TaxZerone
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ opacity: 0.9, fontSize: '13px', mt: 0.5 }}
                    >
                      Best Form 2290 Software for Owner-Operators, Fleets & Tax
                      Preparers
                    </Typography>
                  </Box>

                  {/* <Box
                    sx={{
                      fontWeight: 600,
                      fontSize: '16px',
                      textAlign: 'right',
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 0.8,
                        justifyContent: 'flex-end',
                      }}
                    >
                      <Rating
                        sx={{ color: '#fac108' }}
                        value={4.4}
                        precision={0.1}
                        readOnly
                        size="medium"
                      />{' '}
                      <span>4.4 / 5</span>
                    </Box>
                    <Typography
                      variant="body2"
                      sx={{ opacity: 0.9, fontSize: '13px', mt: 0.8 }}
                    >
                      as per the Trustpilot Review
                    </Typography>
                  </Box> */}
                  <Box
                                      sx={{
                                        backgroundColor: '#30E3B2',
                                        color: '#044E3A',
                                        px: 2.5,
                                        py: 0.8,
                                        borderRadius: '50px',
                                        fontWeight: 700,
                                        fontSize: '13px',
                                      }}
                                    >
                                      Recommended
                                    </Box>
                </Box>

                {/* Card Body */}
                <Box sx={{ p: { xs: 2.5, sm: 4 } }}>
                  <Typography
                    sx={{
                      color: '#64748B',
                      lineHeight: 1.6,
                      fontSize: '14px',
                      mb: 3,
                    }}
                  >
                    TaxZerone is a leading IRS-authorized e-file provider for
                    Form 2290, helping owner-operators, fleets, and trucking tax
                    preparers complete Heavy Vehicle Use Tax filings with speed,
                    accuracy, and confidence. With a guided filing workflow,
                    built-in validation checks, and a stamped Schedule 1
                    delivery in minutes, TaxZerone simplifies the Form 2290
                    e-filing process from start to finish.
                  </Typography>

                  {/* Pros / Cons Table Box */}
                  <Grid
                    container
                    sx={{
                      border: '1px solid #E2E8F0',
                      borderRadius: '12px',
                      backgroundColor: '#F8FAFC',
                      mb: 3,
                      overflow: 'hidden',
                    }}
                  >
                    {/* Pros */}
                    <Grid
                      size={{ xs: 12, md: 6 }}
                      sx={{
                        p: { xs: 2.5, sm: 3 },
                        borderRight: { md: '1px solid #E2E8F0' },
                        borderBottom: { xs: '1px solid #E2E8F0', md: 'none' },
                      }}
                    >
                      <Typography
                        sx={{
                          fontWeight: 700,
                          fontSize: '15px',
                          mb: 2,
                          color: '#0F172A',
                        }}
                      >
                        Pros
                      </Typography>
                      <Stack spacing={1.2}>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Easiest workflow — minimal learning curve
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Secure cloud-based access
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Mobile friendly filing
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Advanced IRS validation checks
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Free VIN checker, Free VIN corrections or
                            retransmissions
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Multi-EIN dashboard for managing many clients
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Bulk upload support for large fleets
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Secure File Upload
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            <strong style={{ fontWeight: 600 }}>
                              {' '}
                              AutoMagic2290{' '}
                            </strong>
                            can use a previous year's Schedule 1 to help
                            populate the current return.
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            <strong style={{ fontWeight: 600 }}>
                              {' '}
                              Call to file Form 2290{' '}
                            </strong>
                            (Full-service filing)
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Supports{' '}
                            <strong style={{ fontWeight: 600 }}>
                              {' '}
                              Form 2290 amendments.
                            </strong>
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Stamped Schedule 1 is available in minutes after IRS
                            approval.
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Save
                            <strong style={{ fontWeight: 600 }}>
                              {' '}
                              10% with prepaid credits which never expire{' '}
                            </strong>
                            .
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            <strong style={{ fontWeight: 600 }}>
                              {' '}
                              Free Mobile app{' '}
                            </strong>
                            available for iOS and Android
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Free HVUT tax calculator
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Flexible payment options
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            US-based bilingual customer support (English &
                            Spanish)
                          </Typography>
                        </Box>
                      </Stack>
                    </Grid>

                    {/* Cons */}
                    <Grid
                      size={{ xs: 12, md: 6 }}
                      sx={{ p: { xs: 2.5, sm: 3 } }}
                    >
                      <Typography
                        sx={{
                          fontWeight: 700,
                          fontSize: '15px',
                          mb: 2,
                          color: '#0F172A',
                        }}
                      >
                        Cons
                      </Typography>
                      <Stack spacing={1.2}>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <ClearIcon
                            sx={{ fontSize: 18, color: '#DC2626', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            The number of features and filing options may feel
                            more extensive than necessary for users with a
                            simple one-vehicle return.
                          </Typography>
                        </Box>
                      </Stack>
                    </Grid>
                  </Grid>

                  {/* Best for & CTA Button */}
                  <Typography
                    sx={{
                      color: '#0F172A',
                      fontSize: '14px',
                      mb: 3,
                    }}
                  >
                    <strong>Best for:</strong> Small to mid-size fleets, Tax
                    professionals and businesses filing multiple returns
                  </Typography>

                  <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                    <Button
                      variant="contained"
                      className="btn-primary"
                      id="tax1099"
                      sx={{
                        mt: 2,
                        px: '20px !important',
                        py: '8px !important',
                        fontSize: '18px !important',

                        transition: 'all 0.3s ease',
                        '&:hover, &:focus, &:active': {
                          transform: 'scale(1.05)',
                        },
                      }}
                      href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=best-form-2290-software`}
                    >
                      Get Started for Free
                    </Button>
                  </Box>
                </Box>
              </Box>
              <Box
                sx={{
                  backgroundColor: '#ffffff',
                  borderRadius: '16px',
                  border: '1px solid #E2E8F0',
                  overflow: 'hidden',
                  boxShadow: '0 4px 20px rgba(0,0,0,0.03)',
                }}
              >
                {/* Header Bar */}
                <Box
                  sx={{
                    paddingTop: { xs: 2.5, md: 3 },
                    paddingLeft: { xs: 3.5, md: 4 },
                    paddingRight: { xs: 3.5, md: 4 },
                    paddingBottom: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    flexWrap: 'wrap',
                    gap: 2,
                  }}
                >
                  <Box>
                    <Typography
                      id="expresstrucktax"
                      variant="h5"
                      sx={{
                        fontWeight: 600,
                        fontSize: { xs: '20px', md: '24px' },
                        scrollMarginTop: 83,
                      }}
                    >
                      ExpressTruckTax
                    </Typography>
                  </Box>

                  {/* <Box
                    sx={{
                      fontWeight: 600,
                      fontSize: '16px',
                      textAlign: 'right',
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 0.8,
                        justifyContent: 'flex-end',
                      }}
                    >
                      <Rating
                        sx={{ color: '#fac108' }}
                        value={4.3}
                        precision={0.1}
                        readOnly
                        size="medium"
                      />{' '}
                      <span>4.3 / 5</span>
                    </Box>
                    <Typography
                      variant="body2"
                      sx={{ opacity: 0.9, fontSize: '13px', mt: 0.8 }}
                    >
                      as per the Trustpilot Review
                    </Typography>
                  </Box> */}
                </Box>

                {/* Card Body */}
                <Box sx={{ p: { xs: 2.5, sm: 4 } }}>
                  <Typography
                    sx={{
                      color: '#64748B',
                      lineHeight: 1.6,
                      fontSize: '14px',
                      mb: 3,
                    }}
                  >
                    ExpressTruckTax is one of the most recognized platforms in
                    the trucking industry. Fleetworthy acquired this platform in
                    2022. It supports Form 2290 filing with a wide range of
                    add-on tools for fleets and trucking businesses.
                  </Typography>

                  {/* Pros / Cons Table Box */}
                  <Grid
                    container
                    sx={{
                      border: '1px solid #E2E8F0',
                      borderRadius: '12px',
                      backgroundColor: '#F8FAFC',
                      mb: 3,
                      overflow: 'hidden',
                    }}
                  >
                    {/* Pros */}
                    <Grid
                      size={{ xs: 12, md: 6 }}
                      sx={{
                        p: { xs: 2.5, sm: 3 },
                        borderRight: { md: '1px solid #E2E8F0' },
                        borderBottom: { xs: '1px solid #E2E8F0', md: 'none' },
                      }}
                    >
                      <Typography
                        sx={{
                          fontWeight: 700,
                          fontSize: '15px',
                          mb: 2,
                          color: '#0F172A',
                        }}
                      >
                        Pros
                      </Typography>
                      <Stack spacing={1.2}>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Guided filing process
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Supports large fleets and bulk filing
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Bulk upload up to 40,000 trucks
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Built-in error checks
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Schedule 1 delivery in minutes after IRS acceptance.
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Free VIN checker
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Mobile app available for iOS and Android
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Vehicle information stored in TruckZone
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Free Retransmission
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Real time updates of your return
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Unlimited tax e-filing plans include both the 2290
                            and 8849.
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Flexible payment options
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Multi-user access
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Offers multiple support channels
                          </Typography>
                        </Box>
                      </Stack>
                    </Grid>

                    {/* Cons */}
                    <Grid
                      size={{ xs: 12, md: 6 }}
                      sx={{ p: { xs: 2.5, sm: 3 } }}
                    >
                      <Typography
                        sx={{
                          fontWeight: 700,
                          fontSize: '15px',
                          mb: 2,
                          color: '#0F172A',
                        }}
                      >
                        Cons
                      </Typography>
                      <Stack spacing={1.2}>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <ClearIcon
                            sx={{ fontSize: 18, color: '#DC2626', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Bit expensive for high-volume filers
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <ClearIcon
                            sx={{ fontSize: 18, color: '#DC2626', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Free VIN corrections are available for returns
                            originally filed through ExpressTruckTax. Other
                            returns may incur a correction fee.
                          </Typography>
                        </Box>
                      </Stack>
                    </Grid>
                  </Grid>
                </Box>
              </Box>
              <Box
                sx={{
                  backgroundColor: '#ffffff',
                  borderRadius: '16px',
                  border: '1px solid #E2E8F0',
                  overflow: 'hidden',
                  boxShadow: '0 4px 20px rgba(0,0,0,0.03)',
                }}
              >
                {/* Header Bar */}
                <Box
                  sx={{
                    paddingTop: { xs: 2.5, md: 3 },
                    paddingLeft: { xs: 3.5, md: 4 },
                    paddingRight: { xs: 3.5, md: 4 },
                    paddingBottom: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    flexWrap: 'wrap',
                    gap: 2,
                  }}
                >
                  <Box>
                    <Typography
                      id="eform2290"
                      variant="h5"
                      sx={{
                        fontWeight: 600,
                        fontSize: { xs: '20px', md: '24px' },
                        scrollMarginTop: 83,
                      }}
                    >
                      eForm2290
                    </Typography>
                  </Box>

                  {/* <Box
                    sx={{
                      fontWeight: 600,
                      fontSize: '16px',
                      textAlign: 'right',
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 0.8,
                        justifyContent: 'flex-end',
                      }}
                    >
                      <Rating
                        sx={{ color: '#fac108' }}
                        value={4.8}
                        precision={0.1}
                        readOnly
                        size="medium"
                      />{' '}
                      <span>4.9 / 5</span>
                    </Box>
                    <Typography
                      variant="body2"
                      sx={{ opacity: 0.9, fontSize: '13px', mt: 0.8 }}
                    >
                      as per the Trustpilot Review
                    </Typography>
                  </Box> */}
                </Box>

                {/* Card Body */}
                <Box sx={{ p: { xs: 2.5, sm: 4 } }}>
                  <Typography
                    sx={{
                      color: '#64748B',
                      lineHeight: 1.6,
                      fontSize: '14px',
                      mb: 3,
                    }}
                  >
                    eForm2290 is an IRS-authorized e-file provider that supports
                    electronic filing for Form 2290. It offers a web-based
                    filing experience for owner-operators and small fleets
                    looking to submit their HVUT return electronically.
                  </Typography>

                  {/* Pros / Cons Table Box */}
                  <Grid
                    container
                    sx={{
                      border: '1px solid #E2E8F0',
                      borderRadius: '12px',
                      backgroundColor: '#F8FAFC',
                      mb: 3,
                      overflow: 'hidden',
                    }}
                  >
                    {/* Pros */}
                    <Grid
                      size={{ xs: 12, md: 6 }}
                      sx={{
                        p: { xs: 2.5, sm: 3 },
                        borderRight: { md: '1px solid #E2E8F0' },
                        borderBottom: { xs: '1px solid #E2E8F0', md: 'none' },
                      }}
                    >
                      <Typography
                        sx={{
                          fontWeight: 700,
                          fontSize: '15px',
                          mb: 2,
                          color: '#0F172A',
                        }}
                      >
                        Pros
                      </Typography>
                      <Stack spacing={1.2}>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Simple online filing workflow
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Bulk upload support
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Basic validation checks before submission
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Offers both self-service filing and phone-assisted
                            “Dial & File” support
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Free VIN corrections and rejected-return
                            retransmissions
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Supports Form 2290 amendments and Form 8849 filings
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Returning users can use previously saved information
                            to simplify future filings
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Schedule 1 delivery after IRS acceptance
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Multi-client dashboard
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Free HVUT tax calculator
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Expert support available
                          </Typography>
                        </Box>
                      </Stack>
                    </Grid>

                    {/* Cons */}
                    <Grid
                      size={{ xs: 12, md: 6 }}
                      sx={{ p: { xs: 2.5, sm: 3 } }}
                    >
                      <Typography
                        sx={{
                          fontWeight: 700,
                          fontSize: '15px',
                          mb: 2,
                          color: '#0F172A',
                        }}
                      >
                        Cons
                      </Typography>
                      <Stack spacing={1.2}>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <ClearIcon
                            sx={{ fontSize: 18, color: '#DC2626', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Users find the interface difficult to navigate
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <ClearIcon
                            sx={{ fontSize: 18, color: '#DC2626', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Pricing higher than some competitors
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <ClearIcon
                            sx={{ fontSize: 18, color: '#DC2626', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Discounts are offered only during select periods.
                          </Typography>
                        </Box>
                      </Stack>
                    </Grid>
                  </Grid>
                </Box>
              </Box>
              <Box
                sx={{
                  backgroundColor: '#ffffff',
                  borderRadius: '16px',
                  border: '1px solid #E2E8F0',
                  overflow: 'hidden',
                  boxShadow: '0 4px 20px rgba(0,0,0,0.03)',
                }}
              >
                {/* Header Bar */}
                <Box
                  sx={{
                    paddingTop: { xs: 2.5, md: 3 },
                    paddingLeft: { xs: 3.5, md: 4 },
                    paddingRight: { xs: 3.5, md: 4 },
                    paddingBottom: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    flexWrap: 'wrap',
                    gap: 2,
                  }}
                >
                  <Box>
                    <Typography
                      id="simpletruck"
                      variant="h5"
                      sx={{
                        fontWeight: 600,
                        fontSize: { xs: '20px', md: '24px' },
                        scrollMarginTop: 83,
                      }}
                    >
                      SimpleTruckTax
                    </Typography>
                  </Box>

                  {/* <Box
                    sx={{
                      fontWeight: 600,
                      fontSize: '16px',
                      textAlign: 'right',
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 0.8,
                        justifyContent: 'flex-end',
                      }}
                    >
                      <Rating
                        sx={{ color: '#fac108' }}
                        value={4.8}
                        precision={0.1}
                        readOnly
                        size="medium"
                      />{' '}
                      <span>4.8 / 5</span>
                    </Box>
                    <Typography
                      variant="body2"
                      sx={{ opacity: 0.9, fontSize: '13px', mt: 0.8 }}
                    >
                      as per the Google reviews
                    </Typography>
                  </Box> */}
                </Box>

                {/* Card Body */}
                <Box sx={{ p: { xs: 2.5, sm: 4 } }}>
                  <Typography
                    sx={{
                      color: '#64748B',
                      lineHeight: 1.6,
                      fontSize: '14px',
                      mb: 3,
                    }}
                  >
                    SimpleTruckTax offers a standard filing experience aimed at
                    first-time filers and owner-operators who want an easy way
                    to submit Form 2290.
                  </Typography>

                  {/* Pros / Cons Table Box */}
                  <Grid
                    container
                    sx={{
                      border: '1px solid #E2E8F0',
                      borderRadius: '12px',
                      backgroundColor: '#F8FAFC',
                      mb: 3,
                      overflow: 'hidden',
                    }}
                  >
                    {/* Pros */}
                    <Grid
                      size={{ xs: 12, md: 6 }}
                      sx={{
                        p: { xs: 2.5, sm: 3 },
                        borderRight: { md: '1px solid #E2E8F0' },
                        borderBottom: { xs: '1px solid #E2E8F0', md: 'none' },
                      }}
                    >
                      <Typography
                        sx={{
                          fontWeight: 700,
                          fontSize: '15px',
                          mb: 2,
                          color: '#0F172A',
                        }}
                      >
                        Pros
                      </Typography>
                      <Stack spacing={1.2}>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Straightforward, beginner-friendly interface
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Basic error checks before submission
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Free first-time e-filing return for your initial
                            truck
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Free VIN corrections
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Bulk upload options for fleets
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Amendment support
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Schedule 1 delivery after IRS acceptance
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Highly Competitive Pricing Tiers
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Flexible payment options
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Prepaid filing credits
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Dedicated 2290 mobile app
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Multi Language support
                          </Typography>
                        </Box>
                      </Stack>
                    </Grid>

                    {/* Cons */}
                    <Grid
                      size={{ xs: 12, md: 6 }}
                      sx={{ p: { xs: 2.5, sm: 3 } }}
                    >
                      <Typography
                        sx={{
                          fontWeight: 700,
                          fontSize: '15px',
                          mb: 2,
                          color: '#0F172A',
                        }}
                      >
                        Cons
                      </Typography>
                      <Stack spacing={1.2}>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <ClearIcon
                            sx={{ fontSize: 18, color: '#DC2626', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            The filing experience may still require users to
                            rely on the step-by-step guides or support.
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <ClearIcon
                            sx={{ fontSize: 18, color: '#DC2626', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            No full-service filing option; users must complete
                            the filing process themselves online.
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <ClearIcon
                            sx={{ fontSize: 18, color: '#DC2626', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            No add-ons supported
                          </Typography>
                        </Box>
                      </Stack>
                    </Grid>
                  </Grid>
                </Box>
              </Box>
              <Box
                sx={{
                  backgroundColor: '#ffffff',
                  borderRadius: '16px',
                  border: '1px solid #E2E8F0',
                  overflow: 'hidden',
                  boxShadow: '0 4px 20px rgba(0,0,0,0.03)',
                }}
              >
                {/* Header Bar */}
                <Box
                  sx={{
                    paddingTop: { xs: 2.5, md: 3 },
                    paddingLeft: { xs: 3.5, md: 4 },
                    paddingRight: { xs: 3.5, md: 4 },
                    paddingBottom: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    flexWrap: 'wrap',
                    gap: 2,
                  }}
                >
                  <Box>
                    <Typography
                      id="ez2290"
                      variant="h5"
                      sx={{
                        fontWeight: 600,
                        fontSize: { xs: '20px', md: '24px' },
                        scrollMarginTop: 83,
                      }}
                    >
                      EZ2290
                    </Typography>
                  </Box>

                  {/* <Box
                    sx={{
                      fontWeight: 600,
                      fontSize: '16px',
                      textAlign: 'right',
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 0.8,
                        justifyContent: 'flex-end',
                      }}
                    >
                      <Rating
                        sx={{ color: '#fac108' }}
                        value={4.1}
                        precision={0.1}
                        readOnly
                        size="medium"
                      />{' '}
                      <span>4.1 / 5</span>
                    </Box>
                    <Typography
                      variant="body2"
                      sx={{ opacity: 0.9, fontSize: '13px', mt: 0.8 }}
                    >
                      as per the Trustpilot reviews
                    </Typography>
                  </Box> */}
                </Box>

                {/* Card Body */}
                <Box sx={{ p: { xs: 2.5, sm: 4 } }}>
                  <Typography
                    sx={{
                      color: '#64748B',
                      lineHeight: 1.6,
                      fontSize: '14px',
                      mb: 3,
                    }}
                  >
                    EZ2290 is an IRS-authorized e-file provider focused on fast
                    2290 filing for owner-operators and small trucking
                    businesses.
                  </Typography>

                  {/* Pros / Cons Table Box */}
                  <Grid
                    container
                    sx={{
                      border: '1px solid #E2E8F0',
                      borderRadius: '12px',
                      backgroundColor: '#F8FAFC',
                      mb: 3,
                      overflow: 'hidden',
                    }}
                  >
                    {/* Pros */}
                    <Grid
                      size={{ xs: 12, md: 6 }}
                      sx={{
                        p: { xs: 2.5, sm: 3 },
                        borderRight: { md: '1px solid #E2E8F0' },
                        borderBottom: { xs: '1px solid #E2E8F0', md: 'none' },
                      }}
                    >
                      <Typography
                        sx={{
                          fontWeight: 700,
                          fontSize: '15px',
                          mb: 2,
                          color: '#0F172A',
                        }}
                      >
                        Pros
                      </Typography>
                      <Stack spacing={1.2}>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Competitive base pricing
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Bulk upload options for fleet owners
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            AI-powered 2290 e-filing features
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Multiple payment options
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Free retransmission
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Automatic HVUT tax calculations
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Built in error prevention with automatic checks
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Support for amendments and filing corrections
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Schedule 1 delivery after IRS acceptance
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Highly secured with 256-bit bank-grade encryption.
                          </Typography>
                        </Box>
                      </Stack>
                    </Grid>

                    {/* Cons */}
                    <Grid
                      size={{ xs: 12, md: 6 }}
                      sx={{ p: { xs: 2.5, sm: 3 } }}
                    >
                      <Typography
                        sx={{
                          fontWeight: 700,
                          fontSize: '15px',
                          mb: 2,
                          color: '#0F172A',
                        }}
                      >
                        Cons
                      </Typography>
                      <Stack spacing={1.2}>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <ClearIcon
                            sx={{ fontSize: 18, color: '#DC2626', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Free VIN corrections are available to users who
                            originally filed their returns through EZ2290. Other
                            returns may incur a correction fee.
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <ClearIcon
                            sx={{ fontSize: 18, color: '#DC2626', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            No dedicated mobile app
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <ClearIcon
                            sx={{ fontSize: 18, color: '#DC2626', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Some fleet-focused tools and features may only be
                            available with certain pricing plans.
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <ClearIcon
                            sx={{ fontSize: 18, color: '#DC2626', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Doesn’t support any other tax form filing besides
                            Form 2290 and related filings.
                          </Typography>
                        </Box>
                      </Stack>
                    </Grid>
                  </Grid>
                </Box>
              </Box>
              <Alert
                icon={
                  <InfoOutlinedIcon sx={{ color: '#475569', fontSize: 22 }} />
                }
                sx={{
                  backgroundColor: '#e0f2fe', // Light cyan background matching image
                  color: '#334155', // Soft slate text color
                  fontSize: { xs: '12px', sm: '13px' },
                  lineHeight: 1.5,
                  borderRadius: '12px',
                  padding: '12px 18px',
                  alignItems: 'center',
                  mb: 2,
                  width: '100%',
                  boxShadow: 'none',
                  '& .MuiAlert-icon': {
                    mr: 1.5,
                    padding: 0,
                  },
                  '& .MuiAlert-message': {
                    padding: 0,
                  },
                }}
              >
                <strong style={{ fontWeight: 600 }}> Disclaimer: </strong>
                All product names, logos, and brands are the property of their
                respective owners. The information provided on this page is
                based on publicly available sources and is intended for general
                informational purposes only. While we strive to keep the
                information accurate and up to date, features, pricing, and
                offerings may change over time. TaxZerone is not affiliated
                with, endorsed by, or sponsored by any of the companies
                mentioned unless explicitly stated.
              </Alert>
            </Stack>
          </Box>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          mx: '0 !important',
          width: '100% !important',
          py: 0,
        }}
        spacing={0}
        m={0}
        component="section"
        aria-labelledby="which-form-2290"
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            m={0}
            mt={7}
            mb={7}
            className="MuiGrid-root-width"
            sx={{ flexDirection: { xs: 'column-reverse', md: 'row' } }}
          >
            <Grid size={{ xs: 12, md: 6 }}>
              <Box
                component="div"
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  textAlign: { xs: 'center', md: 'right' },
                  my: { xs: 3, md: 0 },
                }}
              >
                <picture>
                  <source srcSet="/assets/images/which-form-2290-software-img.webp" />
                  <source srcSet="/assets/images/which-form-2290-software-img.png" />
                  <img
                    src="/assets/images/which-form-2290-software-img.png"
                    alt="which form 2290 software"
                    className="img-responsive"
                    loading="lazy"
                    width={503}
                    height={513}
                  />
                </picture>
              </Box>
            </Grid>
            <Grid
              size={{ xs: 12, md: 6 }}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: {
                  lg: 'left',
                  md: 'left',
                  sm: 'center',
                  xs: 'center',
                },
              }}
            >
              <Box sx={{ mb: { xs: 3, md: 5 }, mt: { xs: -3, md: 5 } }}>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { xl: 48, lg: 42, md: 34, sm: 28, xs: 24 },
                    fontWeight: 600,
                    mb: 3,
                  }}
                >
                  Which Form 2290 Software Is Right for You?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Every trucking business has different filing requirements. The
                  best solution depends on your fleet size, filing frequency,
                  workflow preferences, and compliance needs.
                </Typography>
                <Box
                  component="ul"
                  sx={{
                    listStyleType: 'none',
                    paddingLeft: 0,
                    textAlign: 'left',
                    ml: { xs: 0, sm: 3 },
                    mt: { xs: 0, md: 3 },
                    mb: { xs: 0, md: 3 },
                    '& li': { display: 'flex' },
                  }}
                >
                  {' '}
                  <li
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />{' '}
                    <Box>
                      <span style={{ fontWeight: 600 }}> Choose </span>
                      <Link
                        href="/excise-tax/efile-irs-form-2290-heavy-vehicle-use-tax-online/"
                        sx={{ color: '#2020ff' }}
                      >
                        TaxZerone
                      </Link>
                      &nbsp;if you want an easy-to-use platform with transparent
                      pricing, guided filing, free VIN corrections, tools for
                      owner-operators, fleets, and tax preparers.
                    </Box>
                  </li>
                  <li
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />{' '}
                    <Box>
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        Choose ExpressTruckTax
                      </span>{' '}
                      if you need an extensive fleet management add-on.
                    </Box>
                  </li>
                  <li
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />{' '}
                    <Box>
                      <strong style={{ fontWeight: 600 }}>
                        {' '}
                        Choose eForm2290
                      </strong>{' '}
                      if you need a straightforward web-based filing solution
                      for occasional Form 2290 filings.
                    </Box>
                  </li>
                  <li
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />{' '}
                    <Box>
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        Choose SimpleTruckTax{' '}
                      </span>{' '}
                      if you're a first-time filer looking for the simplest
                      possible experience.{' '}
                    </Box>
                  </li>
                  <li
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />{' '}
                    <Box>
                      <span style={{ fontWeight: 600 }}> Choose EZ2290 </span>{' '}
                      if you're a budget-conscious owner-operator filing for one
                      or two trucks.
                    </Box>
                  </li>
                </Box>
                <Typography variant="body1">
                  Comparing features, pricing, support, and filing workflow
                  before choosing a provider can help you find the platform that
                  best fits your fleet's needs.{' '}
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f6f6fa',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
        }}
        spacing={2}
        m={0}
        component="section"

        aria-labelledby="trusted-business"
      >
        <Container maxWidth="lg" sx={{ px: { xs: 0, sm: 2 } }}>
          <Grid
            container
            spacing={2}
            m={2}
            mt={{ xs: 5, sm: 5, md: 6 }}
            mb={{ xs: 5, sm: 5, md: 8 }}
            className="MuiGrid-root-width"
          >
            <Box
              sx={{
                pt: 6,
                px: 2,
                maxWidth: '1200px',
                mx: 'auto',
                textAlign: 'center',
              }}
            >
              <Box textAlign="center" sx={{ mb: 1 }}>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: {
                      xs: 24,
                      sm: 28,
                      md: 34,
                      lg: 42,
                      xl: 48,
                    },
                    fontWeight: 600,

                    mb: 0,
                  }}
                >
                  Trusted by Businesses Who Made the Switch
                </Typography>
              </Box>

              <Grid container spacing={0} sx={{ mt: 0 }}>
                <Grid
                  size={{ xs: 12, sm: 6, md: 4 }}
                  sx={{
                    border: '1px solid #ccc',
                  }}
                >
                  <Box
                    component="a"
                    href="https://www.trustpilot.com/review/taxzerone.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                      mt: 0,
                      display: 'inline-flex',
                      alignItems: 'center',
                      textDecoration: 'none',
                      cursor: 'pointer',
                      transition: 'transform 0.2s ease',
                      justifyContent: 'center',
                      textAlign: 'center',
                      mx: 'auto',
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        pr: 1.5,
                        mr: 1.5,
                        borderRight: '1px solid #e5e7eb',
                        height: 48,
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: { xs: 20, sm: 23 },
                          fontWeight: 600,
                          fontFamily: 'Arial, sans-serif',
                          color: '#00b67a',
                          letterSpacing: '-0.5px',
                          lineHeight: 1,
                          whiteSpace: 'nowrap',
                        }}
                      >
                        Trustpilot
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                      }}
                    >
                      <Stack
                        direction="row"
                        alignItems="center"
                        spacing={0.7}
                        sx={{
                          height: 20,
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: 14,
                            fontWeight: 700,
                            color: '#172b4d',
                            lineHeight: 1,
                          }}
                        >
                          Excellent
                        </Typography>

                        <Typography
                          sx={{
                            fontSize: 14,
                            fontWeight: 700,
                            color: '#172b4d',
                            lineHeight: 1,
                          }}
                        >
                          4.4
                        </Typography>
                      </Stack>

                      <Stack
                        direction="row"
                        spacing={0.35}
                        sx={{
                          mt: 0.6,
                        }}
                      >
                        {/* Star 1 */}
                        <Box
                          sx={{
                            width: 20,
                            height: 20,
                            backgroundColor: '#00b67a',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <Typography
                            sx={{
                              color: '#fff',
                              fontSize: 14,
                              lineHeight: 1,
                            }}
                          >
                            ★
                          </Typography>
                        </Box>

                        {/* Star 2 */}
                        <Box
                          sx={{
                            width: 20,
                            height: 20,
                            backgroundColor: '#00b67a',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <Typography
                            sx={{
                              color: '#fff',
                              fontSize: 14,
                              lineHeight: 1,
                            }}
                          >
                            ★
                          </Typography>
                        </Box>

                        {/* Star 3 */}
                        <Box
                          sx={{
                            width: 20,
                            height: 20,
                            backgroundColor: '#00b67a',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <Typography
                            sx={{
                              color: '#fff',
                              fontSize: 14,
                              lineHeight: 1,
                            }}
                          >
                            ★
                          </Typography>
                        </Box>

                        {/* Star 4 */}
                        <Box
                          sx={{
                            width: 20,
                            height: 20,
                            backgroundColor: '#00b67a',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <Typography
                            sx={{
                              color: '#fff',
                              fontSize: 14,
                              lineHeight: 1,
                            }}
                          >
                            ★
                          </Typography>
                        </Box>

                        {/* Star 5 - 40% for 4.4 rating */}
                        <Box
                          sx={{
                            width: 20,
                            height: 20,
                            position: 'relative',
                            overflow: 'hidden',
                            backgroundColor: '#d9d9d9',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          {/* Grey Star */}
                          <Typography
                            sx={{
                              position: 'absolute',
                              color: '#ffffff',
                              fontSize: 14,
                              lineHeight: 1,
                            }}
                          >
                            ★
                          </Typography>

                          {/* Green 40% Star */}
                          <Box
                            sx={{
                              position: 'absolute',
                              left: 0,
                              top: 0,
                              width: '40%',
                              height: '100%',
                              overflow: 'hidden',
                              backgroundColor: '#00b67a',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'flex-start',
                            }}
                          >
                            <Typography
                              sx={{
                                width: 20,
                                minWidth: 20,
                                color: '#ffffff',
                                fontSize: 14,
                                lineHeight: 1,
                                textAlign: 'center',
                              }}
                            >
                              ★
                            </Typography>
                          </Box>
                        </Box>
                      </Stack>
                    </Box>
                  </Box>
                </Grid>
                <Grid
                  size={{ xs: 12, sm: 6, md: 4 }}
                  sx={{ border: '1px solid #ccc', borderLeft: 'unset' }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      textAlign: 'left',
                      gap: 1.2,
                      justifyContent: 'center',
                    }}
                  >
                    <Box>
                      <picture>
                        <source srcSet="/assets/images/google-reviews.webp" />
                        <source srcSet="/assets/images/google-reviews.png" />
                        <Box
                          component="img"
                          src="/assets/images/google-reviews.png"
                          loading="lazy"
                          alt="Google Review"
                          width={53}
                          height={58}
                          sx={{
                            width: { xs: 50, md: 53 },
                            height: { xs: 49, md: 58 },
                          }}
                        />
                      </picture>
                    </Box>
                    <Box sx={{ textAlign: 'left' }}>
                      <Typography variant="body1" sx={{ fontWeight: 600 }}>
                        Reviews 5.0
                      </Typography>
                      <Rating
                        value={5}
                        readOnly
                        size="small"
                        sx={{ color: '#EAB308' }}
                      />
                    </Box>
                  </Box>
                </Grid>
                <Grid
                  size={{ xs: 12, sm: 6, md: 4 }}
                  sx={{
                    border: '1px solid #ccc',
                    borderLeft: 'unset',
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      textAlign: 'left',
                      gap: 1.2,
                      justifyContent: 'center',
                    }}
                  >
                    <Box>
                      <picture>
                        <source srcSet="/assets/images/g2-logo-img.webp" />
                        <source srcSet="/assets/images/g2-logo-img.png" />
                        <Box
                          component="img"
                          src="/assets/images/g2-logo-img.png"
                          loading="lazy"
                          alt="G2 logo"
                          width={53}
                          height={58}
                          sx={{
                            width: { xs: 50, md: 53 },
                            height: { xs: 49, md: 58 },
                          }}
                        />
                      </picture>
                    </Box>
                    <Box sx={{ textAlign: 'left' }}>
                      <Typography variant="body1" sx={{ fontWeight: 600 }}>
                        Reviews 5.0
                      </Typography>
                      <Rating
                        value={5}
                        readOnly
                        size="small"
                        sx={{ color: '#EAB308' }}
                      />
                    </Box>
                  </Box>
                </Grid>
                <Grid size={{ xs: 12, md: 4 }} sx={{ px: 2, mt: 4 }}>
                  <Stack spacing={3}>
                    <Paper
                      elevation={0}
                      sx={{
                        p: 3,
                        borderRadius: '16px',
                        border: '1px solid #E2E8F0',
                        backgroundColor: '#ffffff',
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          color: '#475569',
                          lineHeight: 1.6,
                          fontSize: '14px',
                          mb: 2,
                        }}
                      >
                        "We tried a couple of other 2290 platforms before
                        switching to TaxZerone. The pricing is clear and the
                        process is simple."
                      </Typography>
                      <Rating
                        value={5}
                        readOnly
                        size="small"
                        sx={{ color: '#838383', mb: 1.5 }}
                      />
                      <Typography
                        variant="subtitle2"
                        sx={{
                          fontWeight: 600,
                          color: '#0F172A',
                          fontSize: '15px',
                        }}
                      >
                        Robert Hensley
                      </Typography>
                    </Paper>

                    {/* <Paper
                      elevation={0}
                      sx={{
                        p: 3,
                        borderRadius: '16px',
                        backgroundColor: '#E0F2FE', // Light blue fill
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          color: '#334155',
                          lineHeight: 1.6,
                          fontSize: '14px',
                          mb: 2,
                        }}
                      >
                        The phone support team was really patient and walked me
                        through everything step by step. I had no tax knowledge
                        at all going in. TaxZerone made the whole process feel
                        easy and gave me confidence. 10/10.
                      </Typography>
                      <Rating
                        value={5}
                        readOnly
                        size="small"
                        sx={{ color: '#64748B', mb: 1.5 }}
                      />
                      <Typography
                        variant="subtitle2"
                        sx={{
                          fontWeight: 700,
                          color: '#0F172A',
                          fontSize: '15px',
                        }}
                      >
                        Elizabeth Wagner
                      </Typography>
                    </Paper> */}
                  </Stack>
                </Grid>

                <Grid size={{ xs: 12, md: 4 }} sx={{ px: 2, mt: 4 }}>
                  <Stack spacing={3}>
                    <Paper
                      elevation={0}
                      sx={{
                        p: 3,
                        borderRadius: '16px',
                        backgroundColor: '#e2dafc',
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          color: '#334155',
                          lineHeight: 1.6,
                          fontSize: '14px',
                          mb: 2,
                        }}
                      >
                        "We needed a simpler way to handle filings for our whole
                        fleet. The bulk VIN upload feature has saved us hours." 
                      </Typography>
                      <Rating
                        value={5}
                        readOnly
                        size="small"
                        sx={{ color: '#838383', mb: 1.5 }}
                      />
                      <Typography
                        variant="subtitle2"
                        sx={{
                          fontWeight: 600,
                          color: '#0F172A',
                          fontSize: '15px',
                        }}
                      >
                        Daniel Ortiz
                      </Typography>
                    </Paper>
                    {/* 
                    <Paper
                      elevation={0}
                      sx={{
                        p: 3,
                        borderRadius: '16px',
                        border: '1px solid #E2E8F0',
                        backgroundColor: '#ffffff',
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          color: '#475569',
                          lineHeight: 1.6,
                          fontSize: '14px',
                          mb: 2,
                        }}
                      >
                        Really good chat support experience. I wasn&apos;t sure
                        how to complete a few steps, but Kevin guided me clearly
                        and stayed with me until everything was done. Appreciate
                        the help.
                      </Typography>
                      <Rating
                        value={5}
                        readOnly
                        size="small"
                        sx={{ color: '#64748B', mb: 1.5 }}
                      />
                      <Typography
                        variant="subtitle2"
                        sx={{
                          fontWeight: 700,
                          color: '#0F172A',
                          fontSize: '15px',
                        }}
                      >
                        Joseph J Perez
                      </Typography>
                    </Paper> */}
                  </Stack>
                </Grid>

                <Grid size={{ xs: 12, md: 4 }} sx={{ px: 2, mt: 4 }}>
                  <Stack spacing={3}>
                    <Paper
                      elevation={0}
                      sx={{
                        p: 3,
                        borderRadius: '16px',
                        border: '1px solid #E2E8F0',
                        backgroundColor: '#ffffff',
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          color: '#475569',
                          lineHeight: 1.6,
                          fontSize: '14px',
                          mb: 2,
                        }}
                      >
                        "TaxZerone helps us spend less time on filing and more
                        time on the road. Free VIN corrections alone made the
                        switch worth it."
                      </Typography>
                      <Rating
                        value={5}
                        readOnly
                        size="small"
                        sx={{ color: '#838383', mb: 1.5 }}
                      />
                      <Typography
                        variant="subtitle2"
                        sx={{
                          fontWeight: 600,
                          color: '#0F172A',
                          fontSize: '15px',
                        }}
                      >
                        Marcus Whitfield
                      </Typography>
                    </Paper>

                    {/* <Paper
                      elevation={0}
                      sx={{
                        p: 3,
                        borderRadius: '16px',
                        backgroundColor: '#FEF3C7', // Light yellow fill
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          color: '#334155',
                          lineHeight: 1.6,
                          fontSize: '14px',
                          mb: 2,
                        }}
                      >
                        OMG! I cannot believe how wonderful the live support
                        was. The agent Alexia assisted me with everything I
                        needed and fixed all the issues in the most professional
                        and friendly manner. Amazing customer experience. Thank
                        You!
                      </Typography>
                      <Rating
                        value={5}
                        readOnly
                        size="small"
                        sx={{ color: '#64748B', mb: 1.5 }}
                      />
                      <Typography
                        variant="subtitle2"
                        sx={{
                          fontWeight: 700,
                          color: '#0F172A',
                          fontSize: '15px',
                        }}
                      >
                        Luis Echenique
                      </Typography>
                    </Paper> */}
                  </Stack>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Container>
      </Grid>
      <Box
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
        component="section"
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontSize: {
              xs: 24,
              sm: 28,
              md: 34,
              lg: 42,
              xl: 48,
            },
            fontWeight: 600,
            mb: 3,
            lineHeight: 1.2,
          }}
        >
          File Form 2290 the Smarter Way
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontSize: {
              xs: 16,
              sm: 18,
              md: 18,
              lg: 20,
              xl: 22,
            },
            fontWeight: 400,
            color: '#f3f3f3',
            mb: 2,
            lineHeight: 1.5,
          }}
        >
          From single trucks to large fleets, TaxZerone makes Heavy Vehicle Use
          Tax filing simple with <br />
          built-in error checks, bulk VIN uploads, and fast Schedule 1 delivery.
        </Typography>
        <Box component="div" sx={{ margin: 'auto' }}>
          <Button
            variant="contained"
            sx={{
              mt: { xs: 0, sm: 4 },
              mb: { xs: 0, md: 0 },
              color: '#444',
              transition: 'all 0.3s ease 0s',
              '&:hover, &active': {
                backgroundColor: '#213e99 !important',
                color: '#fff',
                transform: 'scale(1.1)',
              },
            }}
            className="btn-secondary-white"
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=best-form-2290-software`}
          >
            Get Started for Free
          </Button>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 3,
              mt: 2,
              flexWrap: 'wrap',
            }}
          >
            <Typography sx={{ color: '#f3f3f3' }}>
              ✓ IRS-authorized e-file
            </Typography>
            <Typography sx={{ color: '#f3f3f3' }}>
              ✓ Free VIN corrections
            </Typography>
            <Typography sx={{ color: '#f3f3f3' }}>
              ✓ Fast Schedule 1 delivery
            </Typography>
          </Box>
        </Box>
      </Box>
      <Grid
        container
        sx={{
          backgroundColor: '#ffffff',
          mx: '0 !important',
          width: '100% !important',
          py: 2,
        }}
        spacing={0}
        m={0}
        component="section"
        aria-labelledby="best-2290-faq"
      >
        <Container maxWidth="lg" sx={{ mb: 0 }}>
          <Grid
            container
            spacing={2}
            m={2}
            direction="row"
            justifyContent="center"
            className="MuiGrid-root-width"
            sx={{ my: { xs: 0, sm: 2, md: 2 } }}
          >
            <Grid
              size={{ xs: 12, sm: 10, md: 9 }}
              textAlign="left"
              mt={{ xs: 2, sm: 1 }}
              mb={2}
            >
              <Typography
                variant="h2"
                id="best-2290-faq"
                sx={{
                  fontSize: {
                    xs: 24,
                    sm: 28,
                    md: 34,
                    lg: 42,
                    xl: 48,
                  },
                  fontWeight: 600,
                  mb: 5,
                  textAlign: 'center',
                }}
              >
                Frequently Asked Questions
              </Typography>

              <Box
                component="div"
                sx={{ mb: 0 }}
                itemScope
                itemType="https://schema.org/FAQPage"
              >
                {/* Question 1 */}
                <Box
                  component="article"
                  itemScope
                  itemProp="mainEntity"
                  itemType="https://schema.org/Question"
                  sx={{
                    border: '1px solid rgba(145, 158, 171, 0.35)',
                    p: 2,
                    mb: 2,
                    backgroundColor: '#fff',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      color: '#36324a',
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                    itemProp="name"
                  >
                    What is the best software to file Form 2290?
                  </Typography>
                  <Box
                    itemScope
                    itemProp="acceptedAnswer"
                    itemType="https://schema.org/Answer"
                  >
                    <Box itemProp="text">
                      <Box component="ul" sx={{ mb: 3, '& li': { mb: 1.5 } }}>
                        <li>
                          The{' '}
                          <Link
                            href="/excise-tax/efile-irs-form-2290-heavy-vehicle-use-tax-online/"
                            sx={{ color: '#0202ff' }}
                          >
                            best Form 2290 software
                          </Link>{' '}
                          is IRS-authorized, easy to use, accurate, and equipped
                          with the features you need.{' '}
                        </li>
                        <li>
                          When comparing providers, look for transparent
                          pricing, automatic error checks, bulk VIN uploads,
                          support for multiple EINs, free VIN corrections, fast
                          IRS-stamped Schedule 1 delivery, and responsive
                          customer support.{' '}
                        </li>
                        <li>
                          For owner-operators, fleets, and tax professionals,
                          <strong style={{ fontWeight: 600 }}>
                            {' '}
                            TaxZerone{' '}
                          </strong>
                          stands out by combining these features with a simple
                          filing experience and reliable support.{' '}
                        </li>
                      </Box>
                    </Box>
                  </Box>
                </Box>

                {/* Question 2 */}
                <Box
                  component="article"
                  itemScope
                  itemProp="mainEntity"
                  itemType="https://schema.org/Question"
                  sx={{
                    border: '1px solid rgba(145, 158, 171, 0.35)',
                    p: 2,
                    mb: 2,
                    backgroundColor: '#fff',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      color: '#36324a',
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                    itemProp="name"
                  >
                    Which software is better for high-volume Form 941 filing?
                  </Typography>
                  <Box
                    itemScope
                    itemProp="acceptedAnswer"
                    itemType="https://schema.org/Answer"
                  >
                    <Box itemProp="text">
                      <Box component="ul" sx={{ mb: 3, '& li': { mb: 1.5 } }}>
                        <li>
                          For high-volume Form 2290 filing, the right software
                          should streamline your workflow and reduce manual
                          effort.{' '}
                        </li>
                        <li>
                          <strong style={{ fontWeight: 600 }}>
                            {' '}
                            TaxZerone{' '}
                          </strong>
                          is built for owner-operators, fleets, and tax
                          professionals who manage multiple filings, offering
                          bulk VIN uploads, multi-EIN management, built-in IRS
                          validation, real-time filing status updates, and
                          flexible pricing.{' '}
                        </li>
                      </Box>
                    </Box>
                  </Box>
                </Box>

                {/* Question 3 */}
                <Box
                  component="article"
                  itemScope
                  itemProp="mainEntity"
                  itemType="https://schema.org/Question"
                  sx={{
                    border: '1px solid rgba(145, 158, 171, 0.35)',
                    p: 2,
                    mb: 2,
                    backgroundColor: '#fff',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      color: '#36324a',
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                    itemProp="name"
                  >
                    How fast can I receive my stamped Schedule 1?
                  </Typography>
                  <Box
                    itemScope
                    itemProp="acceptedAnswer"
                    itemType="https://schema.org/Answer"
                  >
                    <Box itemProp="text">
                      <Box component="ul" sx={{ mb: 3, '& li': { mb: 1.5 } }}>
                        <li>
                          You can receive your
                          <strong style={{ fontWeight: 600 }}>
                            {' '}
                            IRS-stamped Schedule 1 within minutes{' '}
                          </strong>
                          after your Form 2290 return is accepted by the IRS.
                          Processing times may vary depending on IRS system
                          availability, but filing through
                          <strong style={{ fontWeight: 600 }}>
                            {' '}
                            TaxZerone{' '}
                          </strong>
                          helps ensure the fastest possible delivery.{' '}
                        </li>
                        <li>
                          Once your return is accepted by the IRS, your stamped
                          Schedule 1 is emailed to you and made available for
                          download, so you can quickly complete vehicle
                          registration and meet HVUT compliance
                          requirements.{' '}
                        </li>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
    </AppLayout>
  );
};

export default bestform2290software;
